import { createSlice } from '@reduxjs/toolkit';
// import { dispatch } from "redux/store";

export type CustomerState = {
  customer: {
    accountInfo: any;
    email: string;
    found: boolean;
    id: string;
    isDeleted: boolean;
    name: string;
    registrationNumber: string;
    isOnboardingDone: boolean;
    isPaymentModuleEnabled: boolean;
    isManualDocumentModuleEnabled: boolean;
    customTheme: string;
  };
};

const initialState: CustomerState = {
  customer: {
    accountInfo: null,
    email: '',
    found: false,
    id: '',
    isDeleted: false,
    name: '',
    registrationNumber: '',
    isOnboardingDone: false,
    isPaymentModuleEnabled: false,
    isManualDocumentModuleEnabled: false,
    customTheme: '',
  },
};

const slice = createSlice({
  name: 'Customer',
  initialState,
  reducers: {
    loginCustomerAction(state, action) {
      const {
        accountInfo,
        email,
        found,
        id,
        isDeleted,
        name,
        registrationNumber,
        isOnboardingDone,
        isPaymentModuleEnabled,
        isManualDocumentModuleEnabled,
        customTheme,
      } = action.payload;
      state.customer = {
        accountInfo,
        email,
        found,
        id,
        isDeleted,
        name,
        registrationNumber,
        isPaymentModuleEnabled,
        isManualDocumentModuleEnabled,
        isOnboardingDone,
        customTheme: customTheme,
      };
    },
    logoutCustomerAction(state) {
      state.customer = {
        accountInfo: null,
        email: '',
        found: false,
        id: '',
        isDeleted: false,
        name: '',
        registrationNumber: '',
        isOnboardingDone: false,
        isPaymentModuleEnabled: false,
        isManualDocumentModuleEnabled: false,
        customTheme: '',
      };
    },
    updateCustomerOnboardingAction(state, action) {
      let { email, found, id, isDeleted, name, isOnboardingDone } = action.payload;
      state.customer = {
        ...state.customer,
        email,
        found,
        id,
        isDeleted,
        name,
        isOnboardingDone,
      };
    },
  },
});

export default slice.reducer;

export const { loginCustomerAction, logoutCustomerAction, updateCustomerOnboardingAction } =
  slice.actions;
